import dayjs from "dayjs";
import { Attendance, HomeWork, AttendanceById, GqlClassRoom, GqlStudent } from "../types";
import { VariantType } from "notistack";

export const ATTENDANCE_BY_ID: AttendanceById = {
  studentId: 123,
  averageAtttendance: 80,
  averageRating: 5,
  averageHomework: 11,
  homeWorks: 18,
  attendanceData: [
    {
      id: 0,
      date: dayjs(),
      attendance: Attendance.P,
      rating: 5,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 2,
      date: dayjs().subtract(3, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 3,
      date: dayjs().subtract(6, "days"),
      attendance: Attendance.P,
      rating: 3,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 3,
      date: dayjs().subtract(8, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 4,
      date: dayjs().subtract(10, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 5,
      date: dayjs().subtract(12, "days"),
      attendance: Attendance.P,
      rating: 6,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 6,
      date: dayjs().subtract(14, "days"),
      attendance: Attendance.P,
      rating: 3,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 7,
      date: dayjs().subtract(16, "days"),
      attendance: Attendance.A,
      rating: 0,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 9,
      date: dayjs().subtract(18, "days"),
      attendance: Attendance.A,
      rating: 0,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 10,
      date: dayjs().subtract(20, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 11,
      date: dayjs().subtract(22, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 12,
      date: dayjs().subtract(25, "days"),
      attendance: Attendance.P,
      rating: 6,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 13,
      date: dayjs().subtract(27, "days"),
      attendance: Attendance.P,
      rating: 1,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 14,
      date: dayjs().subtract(29, "days"),
      attendance: Attendance.A,
      rating: 0,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 15,
      date: dayjs().subtract(31, "days"),
      attendance: Attendance.P,
      rating: 3,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 16,
      date: dayjs().subtract(33, "days"),
      attendance: Attendance.A,
      rating: 0,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 17,
      date: dayjs().subtract(35, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 18,
      date: dayjs().subtract(37, "days"),
      attendance: Attendance.A,
      rating: 0,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 17,
      date: dayjs().subtract(39, "days"),
      attendance: Attendance.P,
      rating: 1,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 18,
      date: dayjs().subtract(41, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 19,
      date: dayjs().subtract(43, "days"),
      attendance: Attendance.P,
      rating: 4,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 20,
      date: dayjs().subtract(45, "days"),
      attendance: Attendance.P,
      rating: 6,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 21,
      date: dayjs().subtract(47, "days"),
      attendance: Attendance.P,
      rating: 6,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 22,
      date: dayjs().subtract(49, "days"),
      attendance: Attendance.P,
      rating: 6,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 23,
      date: dayjs().subtract(51, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 24,
      date: dayjs().subtract(53, "days"),
      attendance: Attendance.P,
      rating: 1,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.UNDONE,
    },
    {
      id: 25,
      date: dayjs().subtract(55, "days"),
      attendance: Attendance.P,
      rating: 6,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.DONE,
    },
    {
      id: 26,
      date: dayjs().subtract(57, "days"),
      attendance: Attendance.P,
      rating: 1,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 27,
      date: dayjs().subtract(59, "days"),
      attendance: Attendance.P,
      rating: 2,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
    {
      id: 28,
      date: dayjs().subtract(61, "days"),
      attendance: Attendance.A,
      rating: 0,
      classRoom: {
        id: 0,
        studentId: 123,
        classId: 0,
        className: "9 b",
      },
      homeWork: HomeWork.NONE,
    },
  ],
};

export const studentsClassData: GqlStudent[] = [
  {
    id: "0",
    createdAt: new Date().toDateString(),
    name: "Javier",
    avatar: "",
    averageAtttendance: 0,
    averageRating: 0,
    averageHomework: 0,
    ClassRoomId: "1",
  },
  {
    id: "1",
    createdAt: new Date().toDateString(),
    name: "Martina",
    avatar: "",
    averageAtttendance: 0,
    averageRating: 0,
    averageHomework: 0,
    ClassRoomId: "1",
  },
];

export const classesData: GqlClassRoom[] = [
  {
    id: String(Math.random()),
    name: "7b - Deutsch",
    subject: "Deutsch Advances",
    shortName: "7b",
    year: 2023,
    initYear: String(new Date().getDate()),
    endYear: String(new Date().getDate()),
    createdAt: String(new Date().getDate()),
    UserId: "1",
  },
  {
    id: String(Math.random()),
    name: "7b - Advanced Deutsch",
    subject: "Deutsch Advances",
    shortName: "9b",
    year: 2023,
    initYear: String(new Date().getDate()),
    endYear: String(new Date().getDate()),
    createdAt: String(new Date().getDate()),
    UserId: "1",
  },
  {
    id: String(Math.random()),
    name: "8b - Spanish",
    subject: "Deutsch Advances",
    shortName: "8b",
    year: 2023,
    initYear: String(new Date().getDate()),
    endYear: String(new Date().getDate()),
    createdAt: String(new Date().getDate()),
    UserId: "1",
  },
  {
    id: String(Math.random()),
    name: "9b - Advanced Deutsch",
    subject: "Deutsch Advances",
    shortName: "9b",
    year: 2023,
    initYear: String(new Date().getDate()),
    endYear: String(new Date().getDate()),
    createdAt: String(new Date().getDate()),
    UserId: "1",
  },
  {
    id: String(Math.random()),
    name: "10b - Spanish",
    subject: "Deutsch Advances",
    shortName: "10b",
    year: 2023,
    initYear: String(new Date().getDate()),
    endYear: String(new Date().getDate()),
    createdAt: String(new Date().getDate()),
    UserId: "1",
  },
  {
    id: String(Math.random()),
    name: "10b - Advanced Spanish",
    subject: "Deutsch Advances",
    shortName: "10b",
    year: 2023,
    initYear: String(new Date().getDate()),
    endYear: String(new Date().getDate()),
    createdAt: String(new Date().getDate()),
    UserId: "1",
  },
];

export const LIST_COLORS: string[] = [
  "#0e7d79",
  "#7a53be",
  "#2d5ea1",
  "#5b4887",
  "#009e71",
  "#be780d",
  "#25afa9",
  "#db93f0",
  "#5ad7ff",
  "#9664d8",
  "#ff64c6",
  "#23c9ff",
  "#ffbbbe",
  "#ffd612",
  "#2d7722",
];

export const emptyStateClassRooms = [
  {
    classRooms: [
      {
        id: "36",
        name: "10b",
        subject: "Deutsch",
        UserId: "4",
        initYear: "1700002800000",
        endYear: "1731711599999",
        Students: [],
        shortName: "De",
        year: 2023,
        observations: null,
        createdAt: "1697323303005",
      },
    ],
    startYear: 2023,
    endYear: 2024,
  },
  {
    classRooms: [
      {
        id: "37",
        name: "sd",
        subject: "fd",
        UserId: "4",
        initYear: "1668466800000",
        endYear: "1700089199999",
        Students: [],
        shortName: "fd",
        year: 2023,
        observations: null,
        createdAt: "1697323987021",
      },
    ],
    startYear: 2022,
    endYear: 2023,
  },
];

export const studentQualificatinLoadingData = {
  __typename: "Attendance",
  id: "166",
  StudentId: "38",
  attendance: "P",
  rating: "0",
  homeWork: {
    __typename: "Homework",
    id: "222",
    StudentId: "34",
    done: false,
    undone: true,
    none: false,
    date: "1697320800000",
    createdAt: "1697326556672",
  },
  date: "1693185970000",
  createdAt: "1693185983167",
};

export const emptyStateStudentsData: GqlStudent[] = [
  {
    id: "0",
    name: "9b ",
    createdAt: String(new Date().getDate()),
    ClassRoomId: "1",
    Attendances: [],
  },
];

export const FUNC_NOOP = () => {};
export const drawerWidth = 240;
export const drawerCollapsedWidth = 64;
export const drawerWidthMobile = drawerWidth;
export const yearAverageQualificationsDefault = {
  numberOfRatings: 0,
  numberOfAttendances: 0,
  numberOfHomeWorks: 0,
  attendance: 0,
  rating: 0,
  homeworks: 0,
  ratingAvg: 0,
  attendanceAvg: 0,
  homeWorksAvg: 0,
};
export const variantSuccess: VariantType = "success";
export const variantDefault: VariantType = "default";
export const variantError: VariantType = "error";
export const variantInfo: VariantType = "info";
export const variantWarning: VariantType = "warning";
export const MAX_INPUT_NAME_LENGHT = 60;
export const MAX_INPUT_LENGHT = 120;
export const MAX_OBSERVATION_INPUT_LENGHT = 5000;
